module.exports = __webpack_public_path__ + "static/media/error-500.06619e7a.png";